import ApiService from '@/data/services/ApiService'
import { IAddTeam, IGetAllTeam, IPaginationQueryParams, ITeam, ITeamPaged, IUpdateTeam } from '@/data/models'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class TeamApiService extends ApiService {
  static async getPaginated(params: IPaginationQueryParams): Promise<IPaginatedServiceResponse<ITeamPaged>> {
    return this.axios.get('teams', { params: params })
      .then((response: AxiosResponse<IPaginatedServiceResponse<ITeamPaged>>) => response.data)
  }

  static async getAll(): Promise<IServiceResponse<Array<IGetAllTeam>>> {
    return this.axios.get('teams')
      .then((response: AxiosResponse<IServiceResponse<Array<IGetAllTeam>>>) => response.data)
  }

  static async create(data: IAddTeam): Promise<IServiceResponse<ITeam>> {
    return this.axios.post('teams', data)
      .then((response: AxiosResponse<IServiceResponse<ITeam>>) => response.data)
  }

  static async update(data: IUpdateTeam): Promise<IServiceResponse<ITeam>> {
    return this.axios.put(`teams/${data.id}`, data)
      .then((response: AxiosResponse<IServiceResponse<ITeam>>) => response.data)
  }

  static async delete(id: number): Promise<IServiceResponse<boolean>> {
    return this.axios.delete(`teams/${id}`)
      .then((response: AxiosResponse<IServiceResponse<boolean>>) => response.data)
  }

  static async getExternalTeams() {
    return this.axios.get('external/teams').then(response => response.data)
  }

  static async getLatestStats(teamId: number) {
    return this.axios.get(`teams/${teamId}/latest-stats`).then(response => response.data)
  }

  static async getStats(teamId: number, from: string, to: string) {
    return this.axios.get(`teams/${teamId}/stats`, {
      params: {
        from, to
      }
    }).then(response => response.data)
  }
}
